/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiAdminApiTestsIdDelete$Params {
  id: string;
}

export function apiAdminApiTestsIdDelete(http: HttpClient, rootUrl: string, params: ApiAdminApiTestsIdDelete$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, apiAdminApiTestsIdDelete.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as HealthFindrStrictHttpResponse<void>;
    })
  );
}

apiAdminApiTestsIdDelete.PATH = '/api/Admin/ApiTests/{id}';
